import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FeatureCardWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: var(--spacing-lg);
  border-radius: var(--border-radius-lg);
  background-color: var(--color-background);
  box-shadow: var(--shadow-sm);
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: var(--shadow-md);
  }
`;

const IconWrapper = styled.div`
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(30, 136, 229, 0.1);
  border-radius: 50%;
  margin-bottom: var(--spacing-md);
  color: var(--color-primary);
  font-size: 1.75rem;
`;

const Title = styled.h3`
  color: var(--color-text);
  margin-bottom: var(--spacing-sm);
  font-size: 1.25rem;
`;

const Description = styled.p`
  color: var(--color-text-light);
  font-size: 0.95rem;
  margin-bottom: 0;
`;

const FeatureCard = ({ icon, title, description, delay = 0, ...props }) => {
  return (
    <FeatureCardWrapper
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay }}
      {...props}
    >
      <IconWrapper>
        <FontAwesomeIcon icon={icon} />
      </IconWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </FeatureCardWrapper>
  );
};

export default FeatureCard; 